<template>
  <base-currency-offer
    :offer-data="filterData"
    :currency-settings="currencySettings"
    :currency-field-type="currencyFieldType"
    :should-set-default-values="shouldSetDefaultValues">
    <template #default="{ filtersList, setOfferField }">
      <div class="currency-filters-row">
        <currency-field
          v-for="field in filtersList"
          :key="field.fieldData && field.fieldData.id ? field.fieldData.id : field.field._key"
          :field-instance="field"
          :is-disabled="field.fieldData._disabled"
          :class="{
            'currency-filters-row--inline': field.fieldData.is_inline,
            'currency-filters-row--input': field.field.component === 'ui-input',
          }"
          class="currency-filters-row"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          @input="setOfferField($event); $emit('input', filterData._getUpdatedOffer())" />
      </div>
    </template>
  </base-currency-offer>
</template>

<script>
import CurrencyField from 'Components/Currency/CurrencyField.vue';
import BaseCurrencyOffer from 'Components/Currency/BaseCurrencyOffer.vue';

export default {
  name: 'CurrencyFiltersRow',

  components: {
    BaseCurrencyOffer,
    CurrencyField,
  },

  props: {
    currencySettings: {
      type: Object,
      required: true,
    },

    currencyFieldType: {
      type: String,
      default: 'component_view',
      validate: (type) => ['component_view', 'component_edit'].includes(type),
    },

    shouldSetDefaultValues: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      filterData: {},
    };
  },
};
</script>

<style lang="scss" scoped>
  .currency-filters-row {
    --field-font-size: 13px;
    --input-padding: 12px;
    --padding: 12px;
    --elements-padding: 8px 12px 8px 12px;
    --prefix-color: #{$color--basic-dark-gray};
    --prefix-margin: 0 3px 0 0;
    --bg-color: #{$color--additional-menu};
    --background-color: #{$color--additional-menu};
    --background-color--focused: #{$color--additional-menu};
    //--grid-flow: column;

    display: grid;
    align-items: center;
    grid-auto-flow: var(--grid-flow, column);
    grid-auto-columns: minmax(0, 1fr);
    grid-gap: 16px;
  }
</style>
